<div class="additional-notes-rich-text-editor w-full h-[32rem]">  <div #toolbarHost class="additional-notes-rich-text-editor__toolbar-host"></div>
  <div #editor class="additional-notes-rich-text-editor__editor-host"></div>
</div>